import { withSvgIcon } from './withSvgIcon';

export const NewsIcon = withSvgIcon(
  <>
    <path
      d="M2.5 6C2.5 5.05719 2.5 4.58579 2.79289 4.29289C3.08579 4 3.55719 4 4.5 4H15.5C16.4428 4 16.9142 4 17.2071 4.29289C17.5 4.58579 17.5 5.05719 17.5 6V14C17.5 14.9428 17.5 15.4142 17.2071 15.7071C16.9142 16 16.4428 16 15.5 16H4.5C3.55719 16 3.08579 16 2.79289 15.7071C2.5 15.4142 2.5 14.9428 2.5 14V6Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M2.5 6.5L9.52941 10.249C9.82353 10.4059 10.1765 10.4059 10.4706 10.249L17.5 6.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </>,
  { viewBox: '0 0 20 20' },
);
